export const services = state => state.services
export const servicesInWorkOrder = state => state.servicesInWorkOrder
export const service = state => state.service
